/**
 *
 * This file was automatically generated using build-models npm script and should not be edited
 *
 **/
export const GetBillingInvoicesOutputJsonApiModel = {
  id: "",
  "billing-invoices": {
    jsonApi: "hasMany",
    type: "billing-invoices",
  },
};
